import { render, staticRenderFns } from "./DropImage.vue?vue&type=template&id=36893945&scoped=true&"
import script from "./DropImage.vue?vue&type=script&lang=ts&"
export * from "./DropImage.vue?vue&type=script&lang=ts&"
import style0 from "./DropImage.vue?vue&type=style&index=0&id=36893945&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36893945",
  null
  
)

export default component.exports